<template>
    <table class="table text-center">
        <thead>
            <tr>
                <th class="text-center">
                  {{ $t("analysis:transaction:id")}}
                </th>
                <th class="text-center">
                  {{ $t("general:transaction")}}
                </th>
                <th class="text-center">
                    {{ $t("property_iq:tab:deal_type")}}
                </th>
                <th class="text-center">
                  {{ $t("property_iq:tab:transaction_date")}}
                </th>
                <th class="text-center">
                    {{ $t("property_iq:tab:sell_price")}}
                </th>
            </tr>
        </thead>

        <tbody>
            <table-row
                v-for="(item, trans_inx) in transactions"
                :key="`${trans_inx}-${item.id}`"
                :item="item"
            />
        </tbody>
    </table>
</template>

<script>
import "vue-loading-overlay/dist/vue-loading.css";

import TableExtendedRow from "./TableExtendedRow.vue";

export default {
    name: "PropertiesTransactionHistoryTable",
    props:  {
        transactions: {
            type: Array,
            default: () => []
        },
        all_transactions: {
            type: Array,
            default: () => []
        },
    },
    data: function () {
        return {
            uncollapsed_transaction_ids: [],
            additional_transaction_data: {},
        }
    },
    components: {
        "table-row": TableExtendedRow,
    },
}
</script>